/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../../styles/colors';
import { typography, fontWeights } from '../../../../../../styles/typography';
import { MediaQueries } from '../../../../../../styles/Grid';

export const openButton = css(typography.effra48, {
  backgroundColor: colorsPalette.transparent,
  border: 0,
  color: colorsPalette.red,
  cursor: 'pointer',
  fontWeight: fontWeights.medium,
  marginBottom: 9,
  padding: 0,

  [MediaQueries.lgAndUp]: {
    marginBottom: 0,
  },
});

export const solutionHeadline = css({
  borderBottom: `1px solid ${colorsPalette.red20}`,
  pointerEvents: 'none',
});

export const chevronIcon = css({
  fontSize: 14,
  marginLeft: 10,
  pointerEvents: 'none',
  position: 'relative',
  top: -4,
});
